import { render, staticRenderFns } from "./ResourceListItem.vue?vue&type=template&id=696be5bb&scoped=true&"
import script from "./ResourceListItem.vue?vue&type=script&lang=js&"
export * from "./ResourceListItem.vue?vue&type=script&lang=js&"
import style0 from "./ResourceListItem.vue?vue&type=style&index=0&id=696be5bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696be5bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VBtn,VIcon,VListItem,VListItemAction,VListItemAvatar,VListItemContent})
